var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.708 18.744"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.5 18.744H.457a.485.485 0 0 1-.455-.519c.281-4.134 4.177-7.359 8.853-7.359s8.571 3.225 8.853 7.337a.488.488 0 0 1-.974.065c-.26-3.615-3.723-6.428-7.879-6.428-4.177 0-7.64 2.835-7.879 6.45a.49.49 0 0 1-.476.454",
    "data-name": "Path 206"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.854 9.87a4.935 4.935 0 1 1 4.935-4.935A4.933 4.933 0 0 1 8.854 9.87m0-8.874a3.939 3.939 0 1 0 3.939 3.939A3.954 3.954 0 0 0 8.854 1Z",
    "data-name": "Path 207"
  })));
};
export default SvgPeople;